// @flow

import React, { Component } from "react"
import styled from "styled-components"
import DatePicker from "../DatePicker"
import FontIcon from "react-toolbox/lib/font_icon/FontIcon"
import styles from "./styles.css"
import moment from "moment"

const RangeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const PickerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
`

const PickerIcon = styled( FontIcon )`
  position: absolute;
  right: 0;
  bottom: 25px;
  pointer-events: none;
  color: #B0B0B0;
`

const MiddleText = styled.span`
  flex-shrink: 1;
  margin-right: 10px;
  margin-left: 10px;
  color: #B0B0B0;
  width: auto !important;
`

export default class DateRange extends Component {
  props: {
    label?: string,
    value: any,
    onChange: any,
    disabled?: boolean,
    datePickerClassName?: String,
    className?: String,
  }

  setToDate = ( date: ?Date ) => {
    const finalDate = ( date )
      ? moment( date ).format( "YYYY-MM-DD" )
      : date

    this.props.onChange( {
      ...this.props.value,
      to: finalDate,
    } )
  }

  setFromDate = ( date: ?Date ) => {
    const finalDate = ( date )
      ? moment( date ).format( "YYYY-MM-DD" )
      : date

    this.props.onChange( {
      ...this.props.value,
      from: finalDate,
    } )
  }

  prepareDateValue = (val) => {
    return moment(val, 'YYYY-MM-DD').toDate();
  }

  render () {
    const { label, value, onChange, disabled, className, datePickerClassName } = this.props
    return (
      <div className={[ styles.wrapper, className ].join( " " )}>
        {label ? <div>{label}</div> : null }
        <RangeWrapper>
          <PickerWrapper>
            <DatePicker
              maxDate={value ? value.to : undefined}
              value={value ? value.from : undefined}
              readonly={disabled}
              inputClassName={datePickerClassName}
              onChange={this.setFromDate}
              className={styles.datePicker}
            />
            <PickerIcon value="event" />
          </PickerWrapper>
          <MiddleText>até</MiddleText>
          <PickerWrapper>
            <DatePicker
              minDate={value ? value.from : undefined}
              value={value ? value.to : undefined}
              readonly={disabled}
              inputClassName={datePickerClassName}
              onChange={this.setToDate}
              className={styles.datePicker}
            />
            <PickerIcon value="event" />
          </PickerWrapper>
        </RangeWrapper>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DateRange/index.js